import API from '@/views/Fdc/Apis/'
import BriqueChart from '@/components/BriqueChart/BriqueChart.js'

/**
 * Report > Fault Analysis Report - EQP Analysis Chart
 */
export default {
  name: 'EqpAnalysisChart',
  props: {
    parentInfo: {
      type: Object,
      default () {
        return null
      }
    }
  },
  watch: {
    /**
     * parentInfo 변화 감지
     * EQP Analysis Chart data를 조회합니다.
     */
    parentInfo () {
      this.search(this.parentInfo)
    }
  },
  methods: {
    /**
     * EQP Analysis Chart data 조회
     * @param {Object} condition 조회 조건
     */
    async search (condition) {
      if (condition !== null) {
        let payload = {
          fab: condition.fab,
          area: condition.area,
          eqpModel: condition.eqpModel,
          fromDate: condition.fromDate,
          toDate: condition.toDate
        }

        this.condition = condition

        await API.Report.getFaultChartEqps(payload, this.callbackEqpChart)
      } else {
        this.$emit('data-selected', null)
        BriqueChart.deleteTraces(document.getElementById('eqpChart'), 0)
      }
    },
    /**
     * EQP Analysis Chart data 조회 callback
     * @param {*} response EQP Analysis Chart data 조회 결과
     */
    callbackEqpChart (response) {
      if (response && response.status === 200) {
        this.drawChart(response.data)

        if (response.data[0].x.length > 0) {
          this.condition.eqpId = response.data[0].x[0]
          this.$emit('data-selected', this.condition)
        } else {
          this.$emit('data-selected', null)
        }
      }
    },
    /**
     * setInterval 설정
     * @param {*} nSelIndex chart data index
     * 주기적으로 실행하면서 선택된 chart의 data를 조회하여 data가 있을경우 cleareInterval을 실행합니다.
     */
    // resetInterval (nSelIndex) {
    //   let self = this
    //   var flex = this.$refs.eqpChart.chart
    //   this.interval = setInterval(function () {
    //     flex.selection = flex.series[0]
    //     var ele = flex.selection.getPlotElement(nSelIndex)
    //     if (ele) {
    //       clearInterval(self.interval)
    //       flex.selection.collectionView.currentItem = flex.selection.collectionView.items[nSelIndex]
    //       flex.selection.collectionView.currentPosition = nSelIndex
    //     }
    //   }, this.updateInterval)
    // },
    /**
     * Draw Chart
     * @param {*} traces plotly chart data
     */
    drawChart (traces) {
      // private final String name = "Eqp";
      // private final String hovertemplate = "Area: %{text.area}<br>EQP Model: %{text.eqpModel}<br>EQP: %{label}<br>Cnt: %{value:,}<extra></extra>";
      // private final String type = "bar";
      traces.forEach(trace => {
        trace.name = 'EQP'
        trace.type = 'bar'
        trace.hovertemplate = '<b>Area:</b> %{text.area}<br><b>EQP Model:</b> %{text.eqpModel}<br><b>EQP:</b> %{label}<br><b>Cnt:</b> %{value:,}<extra></extra>'
      })
      const layout = {
        legend: {
          orientation: 'h',
          y: 1.2
        },
        hoverlabel: {
          align: 'left'
        }
      }
      const config = {
        responsive: true,
        scrollZoom: true,
        displaylogo: false,
        displayModeBar: true
      }
      BriqueChart.newPlot('eqpChart', traces, layout, config).then(() => {
        let chart = document.querySelector('#eqpChart')
        chart.on('plotly_click', event => {
          this.condition.eqpId = event.points[0].label
          this.$emit('data-selected', this.condition)
        })
      })
    }
  },
  data () {
    return {
      // eqpAnalysisItems: [] // EQP Analysis Chart data
      // selectedIndex: null // 선택된 chart data index
      // interval: null, // setInterval 객체
      // updateInterval: 100 // setInterval 주기
    }
  }
}
